var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 8",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(-90)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9933 0.919912C0.666635 1.24658 0.666635 1.77324 0.9933 2.09991L6.5333 7.63991C6.7933 7.89991 7.2133 7.89991 7.4733 7.63991L13.0133 2.09991C13.34 1.77325 13.34 1.24658 13.0133 0.919912C12.6866 0.593245 12.16 0.593245 11.8333 0.919912L6.99997 5.74658L2.16663 0.913245C1.84663 0.593245 1.3133 0.593245 0.9933 0.919912Z",
    fill: "#FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.d46e128995dba450caa07056e9c09c2d.svg";
export { ForwardRef as ReactComponent };